import { useLocation, useNavigate } from 'react-router-dom'

export function isTrustedMembersPath(pathname, clubCode) {
  if (typeof pathname !== 'string' || !pathname.startsWith('/')) return false
  const root = `/${clubCode}`
  return pathname === root || pathname.startsWith(`${root}/`)
}

export function membersNavigationState(location) {
  return { membersFrom: `${location.pathname}${location.search || ''}${location.hash || ''}` }
}

export function useLetsPlayBack(clubCode, fallback) {
  const location = useLocation()
  const navigate = useNavigate()
  return () => {
    const previous = location.state?.membersFrom
    if (isTrustedMembersPath(previous?.split(/[?#]/, 1)[0], clubCode)) {
      navigate(-1)
      return
    }
    navigate(fallback, { replace: true })
  }
}
